module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0742c_banner_800x600.2249b1b8.png";